import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import Header from './Header';

const BLOG_MAP = {
  'how-to-describe-features': {
    title: 'How to Describe Features Using Vibe Coding Prompts (2025)',
    file: '/blog1.md',
    image: '/lovablelogo.png'
  },
  'best-vibe-coding-tools-2025': {
    title: 'Best Vibe Coding Tools in 2025 — Tested and Ranked',
    file: '/blog2.md',
    image: '/Screenshot 2025-10-28 at 21.18.54.png'
  },
  'prompting-for-vibe-coding-guide': {
    title: 'Prompting for Vibe Coding: A Friendly Guide (with Templates)',
    file: '/blog3.md',
    image: '/valycodelogo.png'
  },
  'how-to-build-effective-app-prompts': {
    title: 'How to Build Effective App Building Prompts?',
    file: '/blog4.md',
    image: '/Screenshot 2025-11-01 at 16.30.49.png'
  },
  'build-mobile-app-claude-code': {
    title: 'How I Built a Full Mobile App in 2 Hours with Claude Code (And You Can Too)',
    file: '/blog5.md',
    image: '/claudecode.png'
  },
  'claude-code-opus-4-7-2026': {
    title: 'How to Build Apps with Claude Code (Opus 4.7) in 2026',
    file: '/blog6.md',
    image: '/aitoolslogos/claude-ai.png'
  }
};

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const blog = useMemo(() => BLOG_MAP[slug], [slug]);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!blog) {
      setError('Not found');
      setLoading(false);
      return;
    }
    let isMounted = true;
    setLoading(true);
    fetch(blog.file)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load');
        return res.text();
      })
      .then((text) => {
        if (isMounted) {
          setContent(text);
          setLoading(false);
        }
      })
      .catch((e) => {
        if (isMounted) {
          setError(e.message || 'Error');
          setLoading(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [blog]);

  if (!blog) {
    return (
      <div className="min-h-screen bg-white">
        <Header onNavigateToHome={() => navigate('/')} />
        <main className="max-w-3xl mx-auto px-6 py-12 pt-24">
          <div className="text-gray-700">This blog post could not be found.</div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header 
        onNavigateToHome={() => navigate('/')}
        onNavigateToDesignInspiration={() => navigate('/design-inspiration')}
        onNavigateToProfile={() => navigate('/profile')}
      />
      <main className="max-w-3xl mx-auto px-6 py-12 pt-24">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-gray-600 hover:text-gray-900 underline mb-6"
        >
          Back
        </button>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">{blog.title}</h1>
        {blog.image ? (
          <div className="mb-8 rounded-xl overflow-hidden border border-gray-200 bg-white">
            <img src={blog.image} alt="Cover" className="w-full object-cover" />
          </div>
        ) : null}

        {loading ? (
          <div className="text-gray-600">Loading…</div>
        ) : error ? (
          <div className="text-red-600">{error}</div>
        ) : (
          <article className="prose prose-zinc max-w-none">
            <ReactMarkdown>{content}</ReactMarkdown>
          </article>
        )}
      </main>
    </div>
  );
};

export default BlogPost;



